var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.vm),expression:"vm"}],staticClass:"img-box",attrs:{"data-src":_vm.src}},[(_vm.slotShow)?_vm._t("default"):_vm._e(),(_vm.errFlag)?_vm._t("err"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }